"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _MerchandiseIdsToUpgradeProducts = require("self-service-api/constants/MerchandiseIdsToUpgradeProducts");

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _LoadingMerchCardAuthedCTAs = _interopRequireDefault(require("pricing-pages-unified-ui/components/loading/LoadingMerchCardAuthedCTAs"));

var _useMerchCardAuthedCTAsProps = require("pricing-pages-unified-ui/components/product-pages/useMerchCardAuthedCTAsProps");

var _PublicCtaDttEnabled = _interopRequireDefault(require("pricing-pages-unified-ui/constants/PublicCtaDttEnabled"));

var _classNames = _interopRequireDefault(require("pricing-pages-unified-ui/utils/classNames"));

var MerchCardCTAsContainer = function MerchCardCTAsContainer(props) {
  var style = props.style,
      className = props.className; // TODO: Gotta figure out how to properly get props through
  // TODO: https://product.hubteam.com/docs/frontend/changes/code-splitting.html

  return _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/auth-cta-motions/AuthedCTAs");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/public-only/MerchCardPublicCTAs");
    },
    authedComponentProps: Object.assign({}, props),
    publicComponentProps: Object.assign({}, props, {
      sourceId: 'pricing-hero',
      dtbSource: "pricing-page|" + props.hub + "-hub|" + _Tracking.MERCH_CARD + "|" + _MerchandiseIdsToUpgradeProducts.MerchandiseIdsToUpgradeProducts[props.merchandiseId]
    }),
    publicComponentLoadingState: function publicComponentLoadingState(_ref) {
      var merchandiseId = _ref.merchandiseId;

      var LoadingButton = function LoadingButton(_ref2) {
        var topMargin = _ref2.topMargin;
        return _react.default.createElement(_UILoadingButton.default, {
          use: "primary",
          style: style,
          className: (0, _classNames.default)('m-x-0', topMargin && 'm-top-2'),
          loading: true
        }, "Loading");
      };

      var content = _react.default.createElement(LoadingButton, null);

      if (_PublicCtaDttEnabled.default.includes(merchandiseId)) {
        content = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(LoadingButton, null), _react.default.createElement(LoadingButton, {
          topMargin: true
        }));
      }

      return _react.default.createElement("div", {
        className: (0, _classNames.default)(className, 'flex-column align-center')
      }, content);
    },
    authedComponentLoadingState: _LoadingMerchCardAuthedCTAs.default,
    useCommonAuthedProps: _useMerchCardAuthedCTAsProps.useMerchCardAuthedCTAsProps,
    preload: true
  });
};

var _default = MerchCardCTAsContainer;
exports.default = _default;
module.exports = exports.default;